import React, { useEffect, useMemo, useRef, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Tooltip } from 'react-leaflet';
import L from 'leaflet';
import "../../../Assets/Css/EmpAttendanceByLocation.scss";
import 'leaflet/dist/leaflet.css';
import moment from 'moment';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

function EmpAttendanceByLocation(props) {
  const [geoLocation, setGeoLocation] = useState([]);
  const [mapCenter, setMapCenter] = useState(null);

  useEffect(() => {
    if (props?.data?.attendance?.length) {
      const geocodingData = props.data.attendance.map(item => {
        try {
          const location = JSON.parse(item.geocoding);
          if (location?.latitude && location?.longitude) {
            return {
              ...location,
              name: item?.user?.name || '',
              date: item?.date || '',
              time: item?.clock_in || '',
              employeeId: item?.user?.id || ''
            };
          }
          return null;
        } catch (error) {
          console.error('Invalid geocoding JSON:', item.geocoding);
          return null;
        }
      }).filter(item => item !== null);

      const userFilterData = props?.selectedUser
        ? geocodingData?.filter(item => item.employeeId === props?.selectedUser?.id)
        : props?.data?.user?.role?.name?.includes('hr')
          ? geocodingData
          : geocodingData?.filter(item => item.employeeId === props?.data?.user?.id);
      setGeoLocation(userFilterData);
    }
  }, [props]);

  useEffect(() => {
    if (geoLocation.length > 0) {
      setMapCenter([geoLocation[0].latitude, geoLocation[0].longitude]);
    }
  }, [geoLocation]);

  const mapKey = useMemo(() => {
    return geoLocation.length ? `${geoLocation[0].latitude}-${geoLocation[0].longitude}` : null;
  }, [geoLocation]);

  return (
    <div className="attendance-table mb-5 mt-2 p-4" style={{ zIndex: 1, position: 'relative' }}>
      {geoLocation.length ? (mapCenter && mapKey && (
        <div className='map-iframe-div'>
          <MapContainer
            key={mapKey}
            center={mapCenter}
            zoom={7}
            scrollWheelZoom={true}
            style={{ height: "500px", width: "100%" }}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            {geoLocation.map((loc, idx) => (
              <Marker key={idx} position={[loc.latitude, loc.longitude]}>
                <Tooltip direction="top" offset={[-14, -10]} permanent>
                  <div>
                    <strong>Name: </strong>{loc.name}<br />
                    <strong>Date: </strong>{loc.date ? moment(loc.date.split(' ')[0]).format('DD/MM/YYYY') : 'N/A'}<br />
                    <strong>Time: </strong>{loc.time || 'N/A'}
                  </div>
                </Tooltip>
              </Marker>
            ))}
          </MapContainer>
        </div>
      )) : <div className="text-center">No Data Found For This User</div>}
    </div>
  );
}

export default EmpAttendanceByLocation;